import universal from 'react-universal-component'

export const UniversalIframeMeeting = universal(props => import('./IframeMeeting'))